var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowMoveLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.23516 10L6.41016 8.825L2.59349 5L6.41016 1.175L5.23516 -1.02722e-07L0.235157 5L5.23516 10Z",
    fill: "#005993"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowMoveLeft);
export default __webpack_public_path__ + "static/media/arrow-move-left.6d37ab67af6d4046c44a138aaac69698.svg";
export { ForwardRef as ReactComponent };